import React, { useEffect, useState } from "react";
import {
  LOADER_TIMEOUT_TIME,
  ORDER_MANAGEMENT_STATUS,
} from "../../../../../utils/Constants";
import { listOrder } from "../../../services/order-management.service";
import { useTranslation } from "react-i18next";
import RecordNotFound from "../../../shared/recordNotFound";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../../admin/common/custompagination";
import quantityImage from "../../../../../assets/restaurant/images/monthsOrdser.png";
import paidImage from "../../../../../assets/restaurant/images/credit.png";
import registeredBusinessesImage from "../../../../../assets/restaurant/images/users.png";
import notesIcon from "../../../../../assets/restaurant/images/notes.png";
import { dashboardApi } from "../../../services/dashboard.service";
import { formateDate } from "../../../../../utils/commonfunction";
import DashboardSummaryCards from "../../../shared/components/DashboardSummaryCards";
import ResponsiveDataTable from "../../../shared/components/ResponsiveDataTable";

export default function OrderManagementDeshboard() {
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const itemPerPage = 10;
  const { t } = useTranslation();
  const [List, setList] = useState([]);
  const [offset, setOffsetPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [totalQuantity, setTotalQuantity] = useState(0);
  const [paidOrders, setPaidOrders] = useState(0);
  const [registeredBusinesses, setRegisteredBusinesses] = useState(0);
  const [thisMonthOrders, setThisMonthOrders] = useState(0);

  const getOrderList = () => {
    setLoader(true);

    const formData = {
      page: page,
      per_page: itemPerPage,
    };

    listOrder(formData)
      .then((response) => {
        const resData = response?.data;

        if (resData && resData.list) {
          setList(resData.list);
          setOffsetPage(resData.offset || 0);
          setTotalRecords(resData.total_records || 0);
        } else {
          setList([]);
          setOffsetPage(0);
          setTotalRecords(0);
        }
      })
      .catch((error) => {
        console.log("Order list error ====> ", error);
        setList([]);
        setOffsetPage(0);
        setTotalRecords(0);
      })
      .finally(() => {
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      });
  };

  useEffect(() => {
    getOrderList();
  }, [page]);

  const summaryCards = [
    {
      titleKey: "label_total_order_quantity",
      value: totalQuantity,
      loader: loader,
      icon: quantityImage,
      link: "/restaurant/order-management/order-management/list/1",
    },
    {
      titleKey: "label_paid",
      value: paidOrders,
      loader: loader,
      icon: paidImage,
      link: "/restaurant/order-management/payment-management/list/1",
    },
    {
      titleKey: "label_registered_businesses",
      value: registeredBusinesses,
      loader: loader,
      icon: registeredBusinessesImage,
      link: "/restaurant/order-management/vendor-management/list/1",
    },
    {
      titleKey: "label_this_month_orders",
      value: thisMonthOrders,
      loader: loader,
      icon: notesIcon,
      link: "/restaurant/order-management/order-management/list/1",
    },
  ];

  const getDashboardData = () => {
    dashboardApi()
      .then((response) => {
        const resData = response?.data;
        if (resData) {
          setTotalQuantity(resData.totalOrders || 0);
          setPaidOrders(resData.paidOrders || 0);
          setRegisteredBusinesses(resData.totalVendors || 0);

          let monthOrdersCount = 0;
          if (resData.monthlyOrders?.length) {
            const currentMonth = new Date().getMonth() + 1;
            const currentYear = new Date().getFullYear();
            const found = resData.monthlyOrders.find(
              (m) => m.year === currentYear && m.month === currentMonth
            );
            if (found) {
              monthOrdersCount = found.count;
            }
          }
          setThisMonthOrders(monthOrdersCount);
        }
      })
      .catch((error) => {
        console.log("dashboard error", error);
      });
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header d-flex align-items-center mb-4">
          <h4 className="heading-title-text">{t("label_dashboard")}</h4>
        </div>

        {/* Summary Cards */}
        <DashboardSummaryCards
          cards={summaryCards.map((card) => ({
            id: card.titleKey,
            title: t(card.titleKey),
            value: card.value,
            loading: card.loader,
            icon: card.icon,
            link: card.link,
          }))}
        />

        {/* Recent Orders */}
        <div className="page-header d-flex align-items-center mb-2">
          <h6 className="heading-title-text">{t("label_recent_orders")}</h6>
        </div>

        <div className="dashboard-content-wraper">
          <div className="category-list-wrap">
            {loader ? (
              <div className="w-100">
                <Skeleton className="mb-2" height={50} count={5} />
              </div>
            ) : List?.length ? (
              <div className="card">
                <div className="card-body">
                  <ResponsiveDataTable>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>{t("label_order_date")}</th>
                          <th>{t("label_company_name")}</th>
                          <th>{t("label_order_product_name")}</th>
                          <th>{t("title_amount")}</th>
                          <th>{t("label_delivery_status")}</th>
                          <th>{t("label_payment_status")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {List.map((item) => (
                          <tr key={item._id}>
                            <td>{item?.order_date ? formateDate(item.order_date) : "-"}</td>
                            <td>{item?.vendorData?.companyName || "-"}</td>
                            <td>
                              {item?.products?.length > 0
                                ? item.products.map((product) => (
                                  <div key={product._id}>
                                    {product.product_name} - {product.quantity} {product.unit}
                                  </div>
                                ))
                                : "-"}
                            </td>
                            <td>₹{item?.order_amount || 0}</td>
                            <td>
                              {item?.delivery_status === ORDER_MANAGEMENT_STATUS.DELEVERED ? (
                                <span
                                  className="status-badge d-block status-badge-success"
                                  style={{ width: "max-content" }}
                                >
                                  {t("label_order_delivery_status_delivered")}
                                </span>
                              ) : item?.delivery_status === ORDER_MANAGEMENT_STATUS.PENDING ? (
                                <span
                                  className="status-badge d-block status-badge-danger"
                                  style={{ width: "max-content" }}
                                >
                                  {t("label_order_delivery_status_pending")}
                                </span>
                              ) : (
                                <span
                                  className="status-badge d-block status-badge-info"
                                  style={{ width: "max-content" }}
                                >
                                  {t("label_unknown")}
                                </span>
                              )}
                            </td>
                            <td>
                              {item?.payment_status === "paid" ? (
                                <span
                                  className="status-badge d-block status-badge-success"
                                  style={{ width: "max-content" }}
                                >
                                  {t("label_paid")}
                                </span>
                              ) : (
                                <span
                                  className="status-badge d-block status-badge-danger"
                                  style={{ width: "max-content" }}
                                >
                                  {t("label_unpaid")}
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </ResponsiveDataTable>

                  <div className="table-status-info d-flex justify-content-between align-items-center mt-3">
                    <span>
                      {t("label_showing_entries", {
                        shown: offset + List.length,
                        total: totalRecords,
                      })}
                    </span>
                    <nav aria-label="Page navigation example">
                      {totalRecords && totalRecords > 0 && (
                        <CustomPagination
                          datalength={totalRecords}
                          itemperpage={itemPerPage}
                          currentPage={page}
                          custompath="page"
                          setPage={setPage}
                          pageRoute={[
                            {
                              name: "vendors",
                              path: "/restaurant/order-management/order-management/list",
                            },
                          ]}
                        />
                      )}
                    </nav>
                  </div>
                </div>
              </div>
            ) : (
              <RecordNotFound heading="no_order_found" />
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
